import {Model} from "@bryntum/schedulerpro";
import {HasProjectMixin} from "./mixins/HasProjectMixin.jsx";

export class NotifyeeBoardUser extends HasProjectMixin(Model) {
  static get $name() {
    return "notifyeeboarduser";
  }

  static get fields() {
    return [
      { name: "boardId", dataSource: "board", type: "integer" },
      { name: "boardUserId", dataSource: "board_user", type: "integer" },
      { name: "resourceId", dataSource: "resource", type: "integer" },
      { name: "clientId", dataSource: "client", type: "integer" },
      { name: "taskId", dataSource: "task", type: "integer" },
      { name: "isGeneralUpdates", dataSource: "is_general_updates", type: "boolean" },
      { name: "isScheduleUpdates", dataSource: "is_schedule_updates", type: "boolean" },
      { name: "isNotesUpdates", dataSource: "is_notes_updates", type: "boolean" },
      { name: "isChecklistUpdates", dataSource: "is_checklist_updates", type: "boolean" },
      { name: "isReminderUpdates", dataSource: "is_reminder_updates", type: "boolean" },
      { name: "isFilesUpdates", dataSource: "is_file_updates", type: "boolean" },
      { name: "createdAt", dataSource: "created_at" },
      { name: "updatedAt", dataSource: "updated_at" },
    ]
  }

  get boardUserRecord() {
    if (this.project) {
      return this.project.boardUsersStore.getById(this.get("boardUserId"));
    }
    return null;
  }

  get boardUserName() {
    if (!this.isGroupHeader) {
      return this.boardUserRecord?.name;
    }
    return null;
  }

  static getEntityInformationByRecord = (notifyUserRecord) => {
    const entityMap = {
      taskId: "Task",
      resourceId: "Resource",
      clientId: "Client"
    };

    const modelKey = Object.keys(entityMap).find((key) => notifyUserRecord[key]);
    const type = entityMap[modelKey];
    const sourceKey = NotifyeeBoardUser.getFieldDefinition(modelKey).dataSource;

    return {
      modelKey,
      sourceKey,
      type
    }
  }
}

NotifyeeBoardUser.exposeProperties();